<template>
  <div id="mentionslegales" class="page">
    <section class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <ol class="breadcrumb">
              <li>
                <router-link to="/">Accueil</router-link>
              </li>
              <li>Mentions Légales</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section class="faq-pg-section section-padding-50">
      <div class="container">
        <div class="row">
            <div class="col-md-8">
                    <div class="section-title-s4">
                      <h1>Site édité par Forestia</h1>
                      <blockquote>
                        OXYNOV® est une marque déposée par FORESTIA®
                      </blockquote>
                      <blockquote>
                      <strong>Forestia</strong><br>
                      2 rue de la Carnoy<br>
                      59130 Lambersart<br>
                      E-mail : contact@forestia.fr<br>
                      Tél : 03.20.07.05.04<br>
                      Siret : 44258432200022 – APE : 7112B<br>
                      www.forestia.fr<br>
                      </blockquote>
                    </div>
                    <div class="section-title-s4">
                      <h1>Site hébergé sur Amazon Web Services</h1>
                      <blockquote>
                       <strong>Amazon Web Services Inc.</strong><br>
                        410 Terry Avenue North,<br>
                        Seattle, WA 98109-5210, USA<br>
                      </blockquote>
                    </div>
                    <div class="section-title-s4">
                      <h1>Collecte de données personnelles</h1>
                      <blockquote>
                       Les informations recueillies font l’objet d’un traitement informatique destiné à la création de devis. Le destinataire des données est FORESTIA.<br><br>
                       Conformément à la loi « informatique et libertés » du 6 janvier 1978 modifiée en 2004, vous bénéficiez d’un droit d’accès et de rectification aux informations qui vous concernent, que vous pouvez exercer en vous adressant à FORESTIA – 2 rue de la Carnoy – 59130 LAMBERSART.<br><br>
                       Vous pouvez également, pour des motifs légitimes, vous opposer au traitement des données vous concernant.<br>
                      </blockquote>
                    </div>
            </div>
            <div class="col-md-4" style="border-left: dashed 1px #d4d4d4;">
                    <Aside/>
            </div>
          </div>
      </div>
      </section>
  </div>
</template>

<script>
import Aside from '../Aside'

export default {
  name: 'Faq',
  components: { Aside }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Mentions.vue